import { render, staticRenderFns } from "./DocumentsDocumentType.vue?vue&type=template&id=54ac5775"
import script from "./DocumentsDocumentType.vue?vue&type=script&lang=js"
export * from "./DocumentsDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports